/**
 * 姓・名を半角スペース区切りで結合する。
 * 一方が空（null / 空文字）の場合は存在する方のみを返し、両方とも空の場合は '-' を返す。
 */
export const composeName = (sei: string | null, mei: string | null): string => {
  const parts = [sei, mei].filter((part): part is string => part != null && part !== '');
  return parts.length > 0 ? parts.join(' ') : '-';
};
